// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pyukumuku: PokeData = {
  "id": 771,
  "name": "pyukumuku",
  "height": 3,
  "weight": 12,
  "base_experience": 144,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "counter",
    "toxic",
    "recover",
    "harden",
    "bide",
    "curse",
    "safeguard",
    "pain-split",
    "baton-pass",
    "memento",
    "taunt",
    "helping-hand",
    "mud-sport",
    "water-sport",
    "gastro-acid",
    "soak",
    "purify"
  ],
  "moves": [
    "curse",
    "purify",
    "rain-dance",
    "aqua-tail",
    "aqua-cutter",
    "brine",
    "life-dew",
    "aqua-jet",
    "bubble",
    "whirlpool",
    "water-spout",
    "hydro-pump",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 398,
    "item": null,
    "species": [
      {
        "name": "pyukumuku",
        "order": 771,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 185,
    "speed": 10,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
